import { useEffect } from 'react'
import useUrlPagination from './use-url-pagination'

const useClientPagination = (rows, { loading = false, defaultPageSize = 20, enabled = true } = {}) => {
  const pagination = useUrlPagination({ defaultPageSize, enabled })
  const totalPages = Math.max(1, Math.ceil(rows.length / pagination.pageSize))
  useEffect(() => {
    if (pagination.active && !loading && rows.length > 0 && pagination.page > totalPages) pagination.setPage(totalPages)
  }, [ pagination.active, loading, rows.length, pagination.page, totalPages, pagination.setPage ])
  return { ...pagination, totalPages, total: rows.length,
    rows: rows.slice((pagination.page - 1) * pagination.pageSize, pagination.page * pagination.pageSize) }
}

export default useClientPagination
